export const DEVELOPMENT_ENV_URL = "http://localhost:3000";
export const PRODUCTION_ENV_URL =
  "https://yuriesoft-shop-custom-backend.vercel.app";

export const CURRENT_ENV_URL = PRODUCTION_ENV_URL;
